import { signUp, SignUpObjectType } from 'utils/auth/sign-up';

export async function signUpAPI(signUpObject: SignUpObjectType) {
  return signUp(signUpObject);
}
